// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "" + chunkId + ".css?v=" + "f6454cfa09dbe991966d" + "";
};